import React from 'react'
import styled from '@emotion/styled'
import { Image } from 'lese'

const AlertImage = styled(Image)`
  width: 25px;
  height: 25px;
`

export default ({ alertEnum, inactiveType, inactiveDays }) => {
  let src

  switch (alertEnum) {
    case 'EMERGENCY':
      src = '/emergency.svg'
      break
    case 'CRITICAL':
      src = '/critical.svg'
      break
    case 'INACTIVE':
      if (inactiveType === 'NO_START') {
        src = '/alert-nostart.svg'
      } else if (inactiveDays === 20) {
        src = '/alert-missed-20.svg'
      } else if (inactiveDays === 40) {
        src = '/alert-missed-40.svg'
      } else if (inactiveDays === 4) {
        src = '/alert-missed-4.svg'
      } else {
        src = ''
      }
      break
    case 'WARNING':
      src = '/warning.svg'
      break
    default:
      src = ''
  }

  if (src === '') {
    return ''
  }

  return <AlertImage src={src} />
}
